export const TAMANHO_CPF = 11;

export const TAMANHO_CNPJ = 14;

export const TAMANHO_CNPJ_SEM_DIGITOS = 12;

export function limparCnpj(valor?: string | null): string {
  return String(valor ?? "")
    .replace(/[^0-9A-Za-z]/g, "")
    .toUpperCase();
}

export function limparCnpjDigitado(valor?: string | null): string {
  const limpo = limparCnpj(valor).slice(0, TAMANHO_CNPJ);

  return (
    limpo.slice(0, TAMANHO_CNPJ_SEM_DIGITOS) +
    limpo.slice(TAMANHO_CNPJ_SEM_DIGITOS).replace(/[^0-9]/g, "")
  );
}

export function limparCpfCnpj(valor?: string | null): string {
  const limpo = limparCnpj(valor);

  return limpo.length <= TAMANHO_CPF ? limpo.replace(/[^0-9]/g, "") : limpo;
}

export function ehCnpj(valor?: string | null): boolean {
  return limparCpfCnpj(valor).length > TAMANHO_CPF;
}

export function cnpjEhAlfanumerico(valor?: string | null): boolean {
  return /[A-Z]/.test(limparCnpj(valor));
}

export function validarCPF(cpf: string): boolean {
  if (!cpf || cpf.length !== TAMANHO_CPF || /^(\d)\1+$/.test(cpf)) return false;

  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }

  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;

  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }

  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;

  return resto === parseInt(cpf.charAt(10));
}

export function calcularDigitoCnpj(base: string): number {
  let posicao = base.length === TAMANHO_CNPJ_SEM_DIGITOS ? 5 : 6;
  let calculo = 0;

  for (let i = 0; i < base.length; i++) {
    calculo += (base.charCodeAt(i) - 48) * posicao;
    posicao--;

    if (posicao < 2) {
      posicao = 9;
    }
  }

  const resto = calculo % 11;

  return resto < 2 ? 0 : 11 - resto;
}

export function validarCNPJ(cnpj: string): boolean {
  const documento = limparCnpj(cnpj);

  if (documento.length !== TAMANHO_CNPJ) return false;

  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(documento)) return false;

  if (/^(.)\1{13}$/.test(documento)) return false;

  const base = documento.substring(0, TAMANHO_CNPJ_SEM_DIGITOS);
  const digito1 = calcularDigitoCnpj(base);
  const digito2 = calcularDigitoCnpj(`${base}${digito1}`);

  return documento === `${base}${digito1}${digito2}`;
}

export function validarCpfCnpj(valor?: string | null): boolean {
  const documento = limparCpfCnpj(valor);

  return documento.length <= TAMANHO_CPF
    ? validarCPF(documento)
    : validarCNPJ(documento);
}
